<template>
<div class="add-list">
    <div class="add-item" v-for="(item,index) in typeData" :key="index">
        <div class="add-title">{{ item.name }}：</div>
        <div class="add-content">
            <!-- 0 文本  1图片 2富文本 3选项 4附件 -->
            <div class="" v-if="item.type_id == 0">
                <Input v-model="item.database_ziduan_name" :placeholder="'请输入'+item.type"></Input>
            </div>
            <div class="" v-if="item.type_id == 1">
                <upload-thumb v-model="item.database_ziduan_name" :ref="item.database_ziduan_name" :defaultList="thumblist" :defaultTip="'建议图片尺寸:320*320'"></upload-thumb>
            </div>
            <div class="" v-if="item.type_id == 2">
                <UEditor v-model="item.database_ziduan_name" :ref="item.database_ziduan_name"></UEditor>
            </div>
            <div class="" v-if="item.type_id == 3">
                <Select v-model="item.database_ziduan_name" :style="{'width':'180px'}">
                    <Option v-for="(item,index) in selectList" :value="index" :key="index">{{ item }}</Option>
                </Select>
            </div>
            <div class="" v-if="item.type_id == 4">
                <upload-file :ref="item.database_ziduan_name" :defaultList="fileList"></upload-file>
            </div>
        </div>
    </div>
    <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="closeFun">取消</Button>
        <Button type="primary" @click="tijiaoFun">提交</Button>
    </div>
</div>
</template>

<script>
import UploadThumb from "../common/thumb";
import UEditor from "../common/ueditor";
import UploadFile from "../common/uploadFile";
export default {
    components: {
        UploadThumb,
        UEditor,
        UploadFile
    },
    data() {
        return {
            wenben: null,
            typeData: [],
            thumb: null,
            thumblist: [],
            content: null,
            selectList: [],
            xuanxiang: null,
            fileList: [],
			list_type_id_wenben: null,
			list_type_id_thumb: null,
			list_type_id_rich: null,
			list_type_id_xuanxiang: null,
			list_type_id_fujian: null
        }
    },
    created() {
        
    },
    methods: {
		/**
		 * @name: 初始的
		 * @return {*}
		 * @desc: 
		 */		
		async initFun(){
			await this.getTypeData();
			this.wenben = null;
            this.typeData = [];
            this.thumb = null;
            this.thumblist = [];
            this.content = null;
            this.selectList = [];
            this.xuanxiang = null;
            this.fileList = [];
			// this.$refs['editContent'].message = '';
			
		},
		/**
		 * @name: 关闭
		 * @return {*}
		 * @desc: 
		 */		
		closeFun(){

		},
        /**
         * @name: 提交
         * @return {*}
         * @desc: 
         */		
        tijiaoFun() {
			let dataArr = [];
			let typeData = this.typeData;
			for(let i in typeData){
				let item = typeData[i];
				console.log('item',item)
				if(item.type_id == 0){
					let obj = {
						list_type_id: item.id,
						content: item.database_ziduan_name,
						type_id: item.type_id
					};
					dataArr.push(obj)
				};
				if(item.type_id == 1){
					let ziduan = item.database_ziduan_name;
					let thumbInstance = this.$refs[ziduan][0].uploadList;
					let obj = {
						list_type_id: item.id,
						type_id: item.type_id,
						content: ''
					};
					if(thumbInstance && thumbInstance.length){
						let str = '';
						for(let i in thumbInstance){
							str += thumbInstance[i].url;
							str += ','
						}
						obj.content = str;
					}
					dataArr.push(obj)
				};
				if(item.type_id == 2){
					let obj = {
						list_type_id: item.id,
						type_id: item.type_id,
						content: ''
					};
					let ziduan = item.database_ziduan_name;
					let editInstance = this.$refs[ziduan][0].message;
					if(editInstance && editInstance.length){
						obj.content = editInstance;
					}
					dataArr.push(obj)
				};
				if(item.type_id == 3){
					let obj = {
						list_type_id: item.id,
						type_id: item.type_id,
						content: ''
					};
					let ziduan = item.database_ziduan_name;
					if(ziduan != null){
						let str = '';
						this.selectList.forEach((el,idx)=>{
							console.log('idx',idx)
							console.log('el',el)
							if(idx == ziduan){
								str = el;
							}
						});
						obj.content = str;
					}
					dataArr.push(obj)
				};
				if(item.type_id == 4){
					let obj = {
						list_type_id: item.id,
						type_id: item.type_id,
						content: ''
					};
					let ziduan = item.database_ziduan_name;
					let fileInstance =  this.$refs[ziduan][0].resList;
					if(fileInstance && fileInstance.length){
						let str = '';
						for(let i in fileInstance){
							str += fileInstance[i].response.result.url;
							str += ',';
						};
						obj.content = str;
					}
					dataArr.push(obj)
				}		
			}
			console.log('dataArr',dataArr);
			this.$api.lists.create({data: dataArr}).then(res=>{
				if(res.code == 200){
					this.$Message.success(res.msg);
					this.$emit('uplist',1);
				}else{
					this.$emit('uplist',-1);
				}
			})
        },
        /**
         * @name: 全部数据
         * @return {*}
         * @desc: 
         */
        getTypeData() {
            let ps = {
                page: 1,
                size: 100
            };
            this.$api.listtype.list(ps).then(res => {
                if (res.code == 200) {
                    this.typeData = res.result.list;
					console.log('字段====',this.typeData)
					for(let i in this.typeData){
						// if(this.typeData[i].type_id == 0){
						// 	this.list_type_id_wenben = this.typeData[i].id;
						// };
						// if(this.typeData[i].type_id == 1){
						// 	this.list_type_id_thumb = this.typeData[i].id;
						// };
						// if(this.typeData[i].type_id == 2){
						// 	this.list_type_id_rich = this.typeData[i].id;
						// };
						// if(this.typeData[i].type_id == 4){
						// 	this.list_type_id_fujian = this.typeData[i].id;
						// }
						if(this.typeData[i].type_id == 3){
							this.list_type_id_xuanxiang = this.typeData[i].id;
							// 查选项的列表
							this.$api.listtype.detail({id: this.typeData[i].id}).then(res=>{
								if(res.code == 200){
									let str = res.result.xuanxiang_content;
									if(str){
										let strArr = str.split(',').filter(item => item != '');
										this.selectList = strArr;
									}
								}
							})
						}
					}
                }
            });
        }
    }
}
</script>

<style scoped>
.add-item{
	margin-top: 20px;
}
.add-content {
    margin-top: 10px;
}
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
/deep/.uploadw{
	position: relative;
}
</style>
